export default {
  baseUrlMicrofrontend: "https://app.dev-auth.surepoint.cloud",
  ssoApiBaseUrl: "https://apiv2.dev-auth.surepoint.cloud",
  addInDomainUrl: "https://addin.dev-auth.surepoint.cloud",
  ICON_BASE_URL:
    "https://frontend-icon-store-nonprod.s3.us-east-2.amazonaws.com/fe-sso/dev/public/",
};

export const env_name = "dev";
